var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('p',{staticClass:"info__label"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._t("default",function(){return [_c('div',{staticClass:"text-content",domProps:{"innerHTML":_vm._s(_vm.sanitizeText)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }